module.exports = __webpack_public_path__ + "static/media/create-wallet-t1.782e6e47.nom";